<script setup>
defineOptions({
    inheritAttrs: false,
})

const props = defineProps({
    file: Object,
    type: {
        type: String,
        default: 'image',
        validator: function (value) {
            // The value must match one of these strings
            return ['image', 'video', 'none'].indexOf(value) !== -1;
        },
    },
});
</script>

<template>
    <template v-if="type == 'image'">
        <img :src="file.url" :alt="file.name" class="rounded img-fluid">
    </template>

    <template v-else-if="type == 'video'">
        <video controls width="300" height="240">
            <source :src="file.url">
            Your browser does not support the video tag.
        </video>
    </template>

    <template v-else>
        <div class="mr-auto">
            <h6 class="font-weight-bold">
                {{ $t('messages.file_name') }}
            </h6>
            <span class="crop-link">{{ file.name }}</span>
        </div>
    </template>
</template>